import { autorun, observable, action, computed } from 'mobx'
import client from '../../../helpers/client'
import { asNormalizedMaps, asNormalizedArrays } from '../../../helpers/json-normalizer'
import { addHours, format } from 'date-fns'
import flatMap from 'lodash/flatMap'


class Store {
  @observable ready = false
  @observable loading = true
  @observable franchise
  @observable miniSession
  @observable miniSessionSlot
  @observable selectedSlot

  constructor({ widgetStore }) {
    this.widgetStore = widgetStore
    this.host = widgetStore.host
  }

  async setup({ miniSessionId }) {
    this.loading = true
    await this.loadFranchise()
    await this.loadMiniSession(miniSessionId)

    this.ready = true
    this.loading = false
  }

  loadFranchise() {
    return client.get(`${this.host}/api/v1/franchise`)
      .then(response => {
        const data = asNormalizedArrays(response.data)
        this.franchise = Object.values(data.franchise)[0]
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  loadMiniSession(miniSessionId) {
    // return client.get(`${this.host}/api/v1/mini_session?include=package_group&include=package_group.event_category`)
    return client.get(`${this.host}/api/v1/mini_sessions/${miniSessionId}?include=mini_session_slots`)
      .then(response => {
        const data = asNormalizedMaps(response.data)
        console.log(data)
        this.miniSession = data.miniSession
        this.miniSessionSlot = data.miniSessionSlot
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  @computed get sortedSlots() {
    const sortedSlots = Array.from(this.miniSessionSlot)
      .map(([id, slot]) => slot)
      .sort((a, b) => a.attributes.startsAt - b.attributes.startsAt)
    console.log(sortedSlots)
    return sortedSlots
  }

  @action progress({ slot }) {
    this.selectedSlot = slot
  }

}

export default Store
